import { Box } from '@chakra-ui/react';
import React, { useContext } from 'react';
import { commonStyle } from '../../../../common/styles';
import { LanguageContext } from '../../../../context/LanguageContextProvider';
import { TransitsContext } from '../../../../context/TransitsContextProvider';

// transitsの最終更新時刻を表示
const UpdateTime = () => {
  const { language } = useContext(LanguageContext);
  const { lastUpdateTime } = useContext(TransitsContext);

  return (
    <>
      <Box
        w='100%'
        h='100%'
        bgColor='#f0f8ff'
        fontSize='14px'
        fontWeight='bold'
        padding='0 10px 0 10px'
        borderTop='solid lightgrey 2px'
        whiteSpace='pre-wrap'
        sx={{ ...commonStyle.center }}
      >
        {lastUpdateTime !== '' &&
          (language === 'en'
            ? `as of ${lastUpdateTime}`
            : `${lastUpdateTime}  現在`)}
      </Box>
    </>
  );
};

export default React.memo(UpdateTime);
